<template>
  <b-form-group
    label="E-Posta"
    label-for="email"
  >
    <b-form-input
      id="email"
      v-model="itemData.email"
      placeholder="E-Posta"
    />
  </b-form-group>
</template>
<script>
import { BFormGroup, BFormInput } from 'bootstrap-vue'

export default {
  name: 'EmailAddress',
  components: { BFormGroup, BFormInput },
  computed: {
    itemData() {
      return this.$store.getters['contacts/dataItem']
    },
  },
}
</script>
